import { render } from "./ModalChooseReturnProduct.vue?vue&type=template&id=ca0aa0ea"
import script from "./ModalChooseReturnProduct.vue?vue&type=script&lang=js"
export * from "./ModalChooseReturnProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__